import {PHP_V13_URL} from "../../api/urls";

export const DynamicFormHelpersEnum = {
    'business-types': {
        key: 'business-types',
        apiPath: `${PHP_V13_URL}/api/helper/${process.env.REACT_APP_VERSION_API}/degree-types`,
        apiProps: { },
        dataPath: {
            results: 'results',
            title: 'title',
            uuid: 'id',
        },
    },
};
